import { IRectangle, List } from '@fluentui/react';
import { AddressModel } from '../../models/AddressModel';
import AddressItemView from './AddressItemView';

type AddressGridProps = {
    addresses: AddressModel[];
    onEdit: (address: AddressModel) => void;
    onDelete: (address: AddressModel) => void;
    onSelect?: (address: AddressModel) => void;
}

export default function AddressGridView({ addresses, onEdit, onDelete, onSelect }: AddressGridProps) {
    var columnCount: number = 0;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            if (surfaceRect != null && surfaceRect.width < 700) columnCount = 1;
            else if (surfaceRect != null && surfaceRect.width < 1050) columnCount = 2;
            else columnCount = 3;
        }

        return addresses.length;
    }

    const onRenderCell = (address?: AddressModel, index?: number, isScrolling?: boolean) => {
        const width = (100 / columnCount) + '%';
        const hPadding = columnCount === 1 ? " ph-10" : "";
        const vPadding = columnCount === 1 ? " pv-10" : " pv-20";

        if (address == null) return <>empty</>;

        return <div
            key={address.id + "-wrapper"}
            className={"list-grid-tile" + vPadding + hPadding}
            style={{ width: width, height: "auto" }}
            data-is-focusable={true}
        >
            <AddressItemView
                key={address.id}
                address={address}
                onEdit={onEdit}
                onDelete={onDelete}
                onSelect={onSelect}
            />
        </div>;
    }

    return <div className="ml--20 mr--20">
        <List
            items={addresses}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}